import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ParentChildsService } from 'src/app/shared-component/parent-childs/parent-childs.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-parent-child-selector',
  templateUrl: './parent-child-selector.component.html',
  styleUrls: ['./parent-child-selector.component.scss'],
  standalone: false
})
export class ParentChildSelectorComponent implements OnInit {
  @Input() visible: boolean = true;
  @Output() studentSelected = new EventEmitter<{ index: number; student: any }>();

  parentStudents: any[] = [];
  public settings: Settings;

  constructor(
    private parentChildsService: ParentChildsService,
    public appSettings: AppSettings,
    private activatedRoute: ActivatedRoute
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit(): void {
    this.loadStudents();

    this.activatedRoute.queryParams.subscribe(params => {
      const studentId = params['StudentId'];
      if (studentId && this.parentStudents.length > 0) {
        const index = this.parentStudents.findIndex(s => s.id === studentId);
        if (index !== -1 && !this.parentStudents[index].isSelected) {
          this.selectStudent(index);
        }
      }
    });
  }

  loadStudents(): void {
    this.parentChildsService.getStudentsByParentId().subscribe(result => {
      let students = result || [];
      const studentId = this.activatedRoute.snapshot.queryParams['StudentId'];
      let selectedIndex = 0;
      if (studentId) {
          const index = students.findIndex(s => s.id === studentId);
          if (index !== -1) {
              selectedIndex = index;
          }
      }

      this.parentStudents = students.map((student, i) => ({ ...student, isSelected: i === selectedIndex }));
      if (this.parentStudents.length > 0) {
        this.studentSelected.emit({ index: selectedIndex, student: this.parentStudents[selectedIndex] });
      }
    });
  }

  selectStudent(index: number): void {
    this.parentStudents = this.parentStudents.map((student, i) => ({ ...student, isSelected: i === index }));
    this.studentSelected.emit({ index, student: this.parentStudents[index] });
  }
}
